import styled from 'styled-components'
import { withOpacity } from '../../helpers'

export default styled.div`
  position: relative;
  display: inline-block;
  text-align: left;

  .pill {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 44px;
    padding: 0 18px;
    border: 1px solid ${ ({ theme }) => withOpacity(theme.colors.white, 50) };
    border-radius: 22px;
    background-color: ${ ({ theme }) => withOpacity(theme.colors.white, 10) };
    color: ${ ({ theme }) => theme.colors.white };
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${ ({ theme }) => withOpacity(theme.colors.white, 20) };
    }

    &:focus-visible {
      outline: 2px solid ${ ({ theme }) => theme.colors.white };
      outline-offset: 2px;
    }

    .code {
      text-transform: uppercase;
    }

    .chevron {
      width: 12px;
      height: 12px;
      transition: transform 0.2s ease;

      &.open {
        transform: rotate(180deg);
      }
    }
  }

  .options {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 20;
    min-width: 200px;
    max-height: 320px;
    overflow-y: auto;
    margin: 0;
    padding: 8px;
    border-radius: 16px;
    background-color: ${ ({ theme }) => theme.colors.white };
    box-shadow: 0 8px 24px ${ ({ theme }) => withOpacity(theme.colors.black, 18) };
    list-style: none;
    box-sizing: border-box;
  }

  .option {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    min-height: 44px;
    padding: 0 12px;
    border: none;
    border-radius: 10px;
    background-color: transparent;
    color: ${ ({ theme }) => theme.colors.black };
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      background-color: ${ ({ theme }) => theme.colors.almostWhite };
    }

    &:focus-visible {
      outline: 2px solid ${ ({ theme }) => theme.colors.accent };
      outline-offset: -2px;
    }

    &.selected {
      background-color: ${ ({ theme }) => theme.colors.accentLight };
      font-weight: 700;
    }

    .code {
      min-width: 22px;
      color: ${ ({ theme }) => theme.colors.accent };
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .pill,
    .pill .chevron {
      transition: none;
    }
  }
`
